"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "DownloadWord___StyledSvg",
  componentId: "sc-1lqyp36-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function DownloadWord(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5l-3-3H6a1 1 0 00-1 1v14a1 1 0 001 1h11a1 1 0 001-1V5zm-4-2v3h3v11H6V3h8z",
    fill: "#707070"
  }), _react["default"].createElement("rect", {
    x: 2,
    y: 6,
    width: 11,
    height: 10,
    rx: 1,
    fill: "#1E5C9E"
  }), _react["default"].createElement("path", {
    d: "M10.621 9L9.47 13H8.172l-.59-2.344a2.386 2.386 0 01-.066-.511h-.024a3.06 3.06 0 01-.078.496L6.781 13H5.5L4.371 9H5.63l.55 2.61c.027.122.046.27.06.445h.023c.013-.183.036-.336.07-.461L7.02 9h1.175l.617 2.61c.016.065.034.216.055.453h.028a4.51 4.51 0 01.062-.454L9.477 9h1.144z",
    fill: "#fff"
  }));
}

var _default = DownloadWord;
exports["default"] = _default;